module.exports = __webpack_public_path__ + "static/media/mapa-a6.13c32855.png";